<template>
  <TransactionFormAmount v-bind="{ ...$attrs, instance }" :entry-index="1" />
</template>

<script setup lang="ts">
import { TransactionClass } from '..'

import TransactionFormAmount from './TransactionFormAmount.vue'

type Props = {
  instance: TransactionClass
}

defineProps<Props>()
</script>
